export const STEP = {
  START: 0,
  DETAILS: 1,
  CONFIGURE: 2,
  OPTIONS: 3,
  REQUIREMENTS: 4,
  PRICING_ADJUSTMENTS: 5,
  REVIEW: 6,
};

export const STEPS = [
  { label: "Start", value: STEP.START, visible: false },
  { label: "Bid Details", value: STEP.DETAILS, visible: true },
  { label: "Configure Bid", value: STEP.CONFIGURE, visible: true },
  { label: "Configure Options", value: STEP.OPTIONS, visible: true },
  { label: "Select Requirements", value: STEP.REQUIREMENTS, visible: true },
  {
    label: "Pricing Adjustments",
    value: STEP.PRICING_ADJUSTMENTS,
    visible: true,
  },
  { label: "Review", value: STEP.REVIEW, visible: true },
];

export const START_OPTION = {
  AREA_TEMPLATES: "areaTemplates",
  COPY: "copyFromExisting",
  SCRATCH: "scratch",
};

export enum DOC_CATEGORY {
  PLAN = "Plan",
  SPEC = "Specification",
  OTHER = "Other",
}

export const AREA_COLUMNS = {
  LEFT: 0,
  RIGHT: 1,
};

export const DEFAULT_OPTION = {
  id: "",
  name: "",
  planAreas: [],
};

export enum BID_STATUS {
  ASSIGNMENT = "Assignment",
  SETUP = "Setup",
  PRICING = "Pricing",
  APPROVED = "Approved",
}

// Bid pricing adjustment constants

export enum TAB_VALUES {
  BID = "Bid",
  OPTIONS = "Options",
  REQUIREMENTS = "Requirements",
}

export const PRICING_TABS = [
  { label: TAB_VALUES.BID, value: TAB_VALUES.BID },
  { label: TAB_VALUES.OPTIONS, value: TAB_VALUES.OPTIONS },
  { label: TAB_VALUES.REQUIREMENTS, value: TAB_VALUES.REQUIREMENTS },
];

export enum ADJUSTMENT_TYPE {
  GLOBAL_BID = "Global Bid",
  GLOBAL_DROP = "Global Drop",
  INDIVIDUAL_DROP = "Individual Drop",
  GLOBAL_ITEM = "Global Item",
  INDIVIDUAL_ITEM = "Individual Item",
}

export const ADJUSTMENT_TYPE_OPTIONS = [
  {
    label: ADJUSTMENT_TYPE.GLOBAL_BID,
    value: ADJUSTMENT_TYPE.GLOBAL_BID,
  },
  {
    label: ADJUSTMENT_TYPE.GLOBAL_DROP,
    value: ADJUSTMENT_TYPE.GLOBAL_DROP,
  },
  {
    label: ADJUSTMENT_TYPE.INDIVIDUAL_DROP,
    value: ADJUSTMENT_TYPE.INDIVIDUAL_DROP,
  },
  {
    label: ADJUSTMENT_TYPE.GLOBAL_ITEM,
    value: ADJUSTMENT_TYPE.GLOBAL_ITEM,
  },
  {
    label: ADJUSTMENT_TYPE.INDIVIDUAL_ITEM,
    value: ADJUSTMENT_TYPE.INDIVIDUAL_ITEM,
  },
];

export const DEFAULT_VALUES = {
  adjustments: {
    label: "",
    type: "",
    amt: 0,
    item: "",
    area: "",
    category: "",
    drop: "",
    notes: "",
  },
};

export const ADJUSTMENT_TYPE_TO_ENUM: Record<string, number> = {
  [ADJUSTMENT_TYPE.GLOBAL_BID]: 0,
  [ADJUSTMENT_TYPE.GLOBAL_ITEM]: 1,
  [ADJUSTMENT_TYPE.INDIVIDUAL_ITEM]: 2,
  [ADJUSTMENT_TYPE.GLOBAL_DROP]: 3,
  [ADJUSTMENT_TYPE.INDIVIDUAL_DROP]: 4,
};
